import F from 'offline/filter/constants'
// Port of api/fuel/app/classes/filter/package/games/collection/package/nesting.php
export default {
	run: function(pkg, local, global) {
		if (global.ownerType !== F.OWNER_USER) return pkg
		pkg.collection = local.collection || {}
		return pkg
	}
}
